export default {
  placeholder: 'Wochentage auswählen',
};
